import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'core/services';
import { filter, map, switchMap } from 'rxjs';

@Component({
  selector: 'ss-core-root-loader-outlet',
  templateUrl: './root-loader-outlet.component.html',
  styleUrls: ['./root-loader-outlet.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RootLoaderOutletComponent {

  readonly loadersObs = this._loaderService.loadersSubject.pipe(
    map(loaders => Object.values(loaders).filter(({ subtle, key }) => !subtle && !key))
  );
  readonly loaderDisplaysObs = this.loadersObs.pipe(
    map((loaders) => loaders
      .filter(loader => loader.text)
      .map((loader) => loader.text)
    ),
    filter((textKeys) => Boolean(textKeys.length)),

    switchMap((textKeys) => this._translateService.get(textKeys)),

    map((translations) => Object.values(translations)),
  )

  constructor(
    private readonly _loaderService: LoaderService,
    private readonly _translateService: TranslateService
  ) {

  }
}
